<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mVHOX4/CoverDesign.jpg?1684514917794" alt="This image is the cover for the book My Hometown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Hometown
      </h1>
      <p class="bookDescription body article font2">
        <p>Jimmy Brink and Eric Halter grew up together in a small country town. While Eric has always been content with life as a rancher, Jimmy wanted more and moved to Chicago early on to pursue a medical career.</p> <p>Life has a way of coming back around. When Jimmy’s parents decide to retire in Florida, Jimmy returns to his hometown to finish his residency at a local hospital. Flamboyant boyfriend Oliver in tow, Jimmy bumps into his old friend. Eric quickly takes a disliking to Oliver, though, and for good reason. Oliver proves he’s not only self-centered but also a cheater.</p> <p>To complicate matters, Eric finds it more and more difficult to hide his attraction to his best friend. When the opportunity arises, he needs to decide whether to risk their friendship to pursue his feelings... but maybe Jimmy will see there’s more for him now than ever before in his hometown.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        SJD Peterson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a101c43